import {
  updateServicesById, updateServicesFileById, insertServices, deleteServicesById, swapKeysById,
} from '../api';

const SwapServicesArgs = (id1, id2, key1, key2) => ({
  id1,
  id2,
  key1,
  key2,
});

const ServicesArgs = (titlePt, titleEs, descriptionPt, descriptionEs, image, key) => ({
  titlePt,
  titleEs,
  descriptionPt,
  descriptionEs,
  image,
  key,
});

export const addService = (
  titlePt,
  titleEs,
  key,
  descriptionPt,
  descriptionEs,
  image,
) => {
  const formData = new FormData();
  formData.append('titlePt', titlePt);
  formData.append('titleEs', titleEs);
  formData.append('key', key);
  formData.append('descriptionPt', descriptionPt);
  formData.append('descriptionEs', descriptionEs);
  formData.append('image', image);

  return insertServices(formData);
};

export const deleteService = (id) => deleteServicesById(id);

export const updateServiceFile = (
  id,
  titlePt,
  titleEs,
  descriptionPt,
  descriptionEs,
  image,
  key,
) => {
  const formData = new FormData();
  formData.append('titlePt', titlePt);
  formData.append('titleEs', titleEs);
  formData.append('key', key);
  formData.append('descriptionPt', descriptionPt);
  formData.append('descriptionEs', descriptionEs);
  formData.append('image', image);

  return updateServicesFileById(
    id,
    formData,
  );
};

export const updateService = (
  id,
  titlePt,
  titleEs,
  descriptionPt,
  descriptionEs,
  image,
  key,
) => updateServicesById(
  id,
  ServicesArgs(
    titlePt,
    titleEs,
    descriptionPt,
    descriptionEs,
    image,
    key,
  ),
);

export const swapKeys = (
  id1,
  id2,
  key1,
  key2,
) => swapKeysById(SwapServicesArgs(id1, id2, key1, key2));
